import { render, staticRenderFns } from "./EditTextItem.vue?vue&type=template&id=3d87d62c&"
import script from "./EditTextItem.vue?vue&type=script&lang=ts&"
export * from "./EditTextItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports